import { helpers } from 'vuelidate/lib/validators'
import moment from 'moment'

export default date =>
  helpers.withParams(
    { type: 'isValidDateOfBirth' },
    function(value, parentVm) {
        var validInput = moment(moment(value, "MM/DD/YYYY", true)).isValid();
        if (validInput) {
            return true
        } else {
            return false
        }
    }
  )